export default __webpack_public_path__ + "static/media/placeholder.c45469df.svg";